/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadAssignmentRequest
 */
export interface UpdateLeadAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadAssignmentRequest
     */
    user_id: string;
}

/**
 * Check if a given object implements the UpdateLeadAssignmentRequest interface.
 */
export function instanceOfUpdateLeadAssignmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;

    return isInstance;
}

export function UpdateLeadAssignmentRequestFromJSON(json: any): UpdateLeadAssignmentRequest {
    return UpdateLeadAssignmentRequestFromJSONTyped(json, false);
}

export function UpdateLeadAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadAssignmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
    };
}

export function UpdateLeadAssignmentRequestToJSON(value?: UpdateLeadAssignmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
    };
}

